import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import Layout from './components/Layout'
import DashboardPage from './pages/DashboardPage'
import PartyCreatePage from './pages/PartyCreatePage'
import HistoryPage from './pages/HistoryPage'
import PartyDetailPage from './pages/PartyDetailPage'
import LoginPage from './pages/LoginPage'

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600"></div>
      </div>
    )
  }

  if (!user) {
    return <LoginPage />
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/create" element={<PartyCreatePage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/parties/:id" element={<PartyDetailPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
